module.exports = __webpack_public_path__ + "img/menu-bar-off_05.2e09a5bc.png";